const BulbIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18h6"/>
    <path d="M10 21h4"/>
    <path d="M12 2a7 7 0 0 1 7 7c0 3-1.8 5.4-4 6.5V17H9v-1.5C6.8 14.4 5 12 5 9a7 7 0 0 1 7-7z"/>
  </svg>
);

export { BulbIcon };
